import { render } from "./ReadingDevicesPage.vue?vue&type=template&id=5c667d97&scoped=true"
import script from "./ReadingDevicesPage.vue?vue&type=script&lang=js"
export * from "./ReadingDevicesPage.vue?vue&type=script&lang=js"

import "./ReadingDevicesPage.vue?vue&type=style&index=0&id=5c667d97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c667d97"]])

export default __exports__